// Заглушка загрузки: несколько плашек-скелетонов на месте будущих карточек.
export function Loading({ rows = 3 }: { rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <div className="skeleton" key={i} />
      ))}
    </>
  )
}
